import script from "./AddToCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./AddToCategory.vue?vue&type=script&setup=true&lang=js"

export default script